import { globalGtm } from "@2u-landing-pages/constants";
import cohesion from "@2u-landing-pages/constants/cohesion";
import Script from "next/script";
import React from "react";

interface GoogleTagsSnippetProps {
  gtagId?: string;
  lob?: string;
  school?: string;
  program?: string;
  multiProgram?: boolean;
}

const getId = (data: GoogleTagsSnippetProps) => {
  const { gtagId, lob = "", school = "", program = "" } = data;
  return gtagId || globalGtm[lob as keyof typeof globalGtm] || cohesion.make[lob]?.[school]?.[program]?.gtagId || "";
};

const getSrc = (data: GoogleTagsSnippetProps) => {
  const { lob = "", school = "", program = "", multiProgram = false } = data;
  const testProgram = school === "unc" && program === "mba";
  return lob === "degree" && (multiProgram || testProgram) ? "degree.edx.org/k7m4nz/" : "www.googletagmanager.com/";
};

export const GoogleTagsSnippet: React.FC<GoogleTagsSnippetProps> = (props) => {
  const id = getId(props);

  if (!id) return null;

  const src = getSrc(props);

  return (
    <Script id="google-tags">
      {`
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://${src}gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${id}');
      `}
    </Script>
  );
};

export const GoogleTagsPixel: React.FC<GoogleTagsSnippetProps> = (props) => {
  const id = getId(props);

  if (!id) return null;

  const src = getSrc(props);

  return (
    <noscript>
      <iframe
        src={`https://${src}ns.html?id=${id}`}
        height="0"
        width="0"
        style={{
          display: "none",
          visibility: "hidden",
        }}
      />
    </noscript>
  );
};
